<template>
    <div class="max-w-sm w-full flex flex-col space-y-8 py-12 shrink-0">
        <div class="bg-white pt-5 px-7 pb-7 rounded-lg shadow-[-1px_1px_7px_1px_rgba(0,0,0,0.05)]">
            <h3 class="text-[20px] leading-7 text-black font-medium">Progress</h3>
            <div class="pt-5">
                <div class="flex justify-between items-center pb-2.5">
                    <p class="text-sm text-[#535353] font-normal">Organization Settings</p>
                    <p class="text-sm text-[#535353] font-normal">{{ orgSettingPercentage }}%</p>
                </div>
                <div class="h-2 bg-[#EDEFEF] rounded relative">
                    <span class="absolute left-0 top-0 h-full rounded" :class="orgSettingPercentage == 100 ? 'bg-[#15CB0F]' : 'bg-[#3B82F6]'" :style="{ width: orgSettingPercentage + '%' }"></span>
                </div>
            </div>

            <!-- <div class="bg-white border px-4 py-3 mt-3 rounded">
                <div class="">
                    <div class="flex justify-between items-center">
                        <p class="text-base text-neutral-700">Attendance Settings</p>
                        <p class="text-sm text-blue-400 font-medium">{{attendance_Setting_percentage}}%</p>
                    </div>
                </div>
                <div class="bg-neutral-100 rounded h-1 relative mt-3">
                    <div class=" h-1 bg-blue-400 rounded" :style="{width : attendance_Setting_percentage + '%'}"></div>
                </div> -->
            <!-- <div class="pt-1.5">
                    <p class="text-xs text-neutral-400">50% of required general settings</p>
                </div> -->
            <!-- </div> -->

            <div class="pt-5">
                <div class="flex justify-between items-center pb-2.5">
                    <p class="text-sm text-[#535353] font-normal">Leave Settings</p>
                    <p class="text-sm text-[#535353] font-normal">{{ leave_Setting_percentage }}%</p>
                </div>
                <div class="h-2 bg-[#E4FFE3] rounded relative">
                    <span class="absolute left-0 top-0 h-full bg-[#15CB0F] rounded"
                        :style="{ width: leave_Setting_percentage + '%' }"></span>
                </div>
            </div>

            <!-- <div class="bg-white border px-4 py-3 mt-3 rounded">
                <div class="">
                    <div class="flex justify-between items-center">
                        <p class="text-base text-neutral-700">User Creation Settings</p>
                        <p class="text-sm text-blue-400 font-medium">{{addemp_Setting_percentage}}%</p>
                    </div>
                </div>
                <div class="bg-neutral-100 rounded h-1 relative mt-3">
                    <div class="h-1 bg-blue-400 rounded" :style="{width : addemp_Setting_percentage + '%'}"></div>
                </div> -->
            <!-- <div class="pt-1.5">
                    <p class="text-xs text-neutral-400">80% of required general settings</p>
                </div> -->
            <!-- </div> -->
        </div>
        <!-- <div class="pt-10" >
            <div class="flex justify-between">
                <p class="font-medium text-lg text-neutral-800">Today’s Shifts</p>
                
                <button class="inline-flex rounded border border-neutral-200 bg-neutral-50 p-1.5 text-sm text-neutral-400 hover:bg-blue-500 hover:text-white focus:outline-none transition-all w-7 h-7">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                </button>
            </div>
            <div class="pt-2" v-for="(data, index) in rosterdetails" :key="index">
                <div class="bg-white border px-4 pt-3 pb-4 mt-3 rounded">
                    <div class="">
                        <div class="flex justify-between items-center">
                            <p class="text-base text-neutral-800">{{data.rosterName}} </p>
                            
                            <button class="w-7 h-7 hover:bg-blue-50 text-neutral-500 hover:text-blue-600 rounded-full text-center transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mx-auto">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="w-40 flex items-center mt-2">
                        <div class="bg-neutral-100 w-36 rounded h-0.5 w- relative">
                            <div class="w-[85%] h-0.5 bg-blue-400  rounded"></div>
                        </div>
                        <p class="text-xs pl-2 text-blue-400 font-medium">80%</p>
                    </div>
                    
                    <div class="pt-5 grid grid-cols-2">
                        <div>
                            <p class="text-xs text-neutral-400">Time</p>
                            <p class="font-medium text-sm pt-2">{{data.fromHours}} - {{ data.toHours }}</p>
                        </div>

                        <div class="flex justify-end">
                            <div class="ml-auto">
                                <p class="text-xs text-neutral-400">Members</p>
                                <dd class="flex justify-end sm:justify-start lg:justify-end xl:justify-start -space-x-1.5 pt-2">
                                    <img src="@/assets/user.png" alt="user name" class="w-5 h-5 rounded-full bg-slate-100 ring-2 ring-white" >
                                    <img src="@/assets/user.png" alt="user name" class="w-5 h-5 rounded-full bg-slate-100 ring-2 ring-white" >

                                    <img src="@/assets/user.png" alt="user name" class="w-5 h-5 rounded-full bg-slate-100 ring-2 ring-white" >
                                    <img src="@/assets/user.png" alt="user name" class="w-5 h-5 rounded-full bg-slate-100 ring-2 ring-white" >
                                    <span class="w-5 text-[9px] leading-5 font-medium text-center h-5 rounded-full bg-blue-500 text-white ring-2 ring-white" >
                                        25+
                                    </span>
                                </dd>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div> -->
        <div class="bg-white pt-5 px-7 pb-7 rounded-lg shadow-[-1px_1px_7px_1px_rgba(0,0,0,0.05)]">
            <h3 class="text-[20px] leading-7 text-black font-medium">New Joinee</h3>
            <div class="pt-4">
                <div v-for="(data, index) in newjoineeList" :key="index" class="flex items-center space-x-3 shadow-lg shadow-transparent hover:bg-white hover:shadow-lg hover:shadow-neutral-100 py-4 rounded">
                    <img class="w-11 h-11 shrink-0 object-cover rounded-full"
                        :src="data.profile_image ? baseUrl + data.profile_image : require('@/assets/user.png')"
                        @error="event => event.target.src = require('@/assets/user.png')" alt="User Profile" />
                    <div class="grow">
                        <p class=" text-black font-medium text-base truncate">{{ data.fname }} {{ data.lname }}</p>
                        <p class="text-xs font-normnal text-[#707070]">{{ data.jobtitle }}</p>
                    </div>
                    <div class="max-w-20 h-7 ml-auto text-xs text-[#3B82F6]">
                        {{ formatDate(data.doj) }}
                    </div>
                </div>
            </div>
        </div>
        <div>
            <TabGroup>
                <TabList class="flex">
                    <Tab v-for="items in EventCategories" as="template" :key="items.id" v-slot="{ selected }">
                        <button :class="['flex items-center justify-center w-1/3 px-3 py-1.5 text-sm font-medium rounded-t-lg text-left', 'focus:outline-none',
                            selected
                                ? 'text-[#3B82F6] bg-white shadow-[0_-2px_6px_1px_rgba(0,0,0,0.05)]'
                                : 'text-[#767676] hover:text-[#3B82F6]',
                        ]">
                            <span>{{ items.name }}</span>
                        </button>
                    </Tab>
                </TabList>
                <div class="glob_tablewpr bg-white rounded-tl-none rounded-lg px-7 py-2">
                    <TabPanels class="mt-2">
                        <TabPanel>
                            <div class="overflow-y-auto max-h-40 space-y-3">
                                <div v-if="birthdays.length">
                                    <div v-for="employee in birthdays" :key="employee.id" class="flex items-center space-x-3 shadow-lg shadow-transparent hover:bg-white hover:shadow-lg hover:shadow-neutral-100 py-3.5 rounded">
                                        <img class="w-11 h-11 shrink-0 object-cover rounded-full" :src="employee.profile_image ? baseUrl + employee.profile_image : require('@/assets/user.png')" @error="event => event.target.src = require('@/assets/user.png')" :alt="employee.fname" />
                                        <div class="grow text-wrap">
                                            <p class=" text-black font-medium text-base leading-5">{{ employee.fname }} {{ employee.lname }}</p>
                                            <p class="text-xs font-normnal text-[#707070] pt-1">{{ employee.jobtitle }}</p>
                                        </div>
                                        <div class="flex items-center justify-center shrink-0 w-24 h-7 ml-auto text-xs bg-[#ECF6FF] text-[#3B82F6] border border-[#0086FF] rounded-2xl">
                                            {{ formatDate(employee.dob) }}
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center text-neutral-500 text-sm py-4">
                                    No data available.
                                </div>
                            </div>
                        </TabPanel>


                        <TabPanel>
                            <div class="overflow-y-auto max-h-40 space-y-3">
                                <div v-if="anniversaries.length">
                                    <div v-for="employee in anniversaries" :key="employee.id" class="flex py-3.5">
                                        <div class="w-14 h-14 relative shrink-0">
                                            <img class="w-full h-full rounded-full object-cover" :src="employee.profile_image ? baseUrl + employee.profile_image : require('@/assets/user.png')" @error="event => event.target.src = require('@/assets/user.png')" :alt="employee.fname" />
                                            <span class="text-white w-7 h-7 absolute -bottom-1 -right-1 flex justify-center items-center bg-[#62c593] rounded-full">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                                    viewBox="0 0 1024 1024">
                                                    <path fill="currentColor"
                                                        d="M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9M200.4 208h624v395h-624zm228.3 608l8.1-37h150.3l8.1 37zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149z" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div class="pl-4">
                                            <p class="font-normal text-neutral-700 text-sm">
                                                <span class="font-medium">{{ employee.fname }} {{ employee.lname }}</span>
                                                has successfully completed {{ getYears(employee.doj) }}
                                                {{ getYears(employee.doj) === 1 ? 'Year' : 'Years' }} in this organization.
                                                Let's congratulate {{ getGenderPronoun(employee.gender) }}.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="text-center text-neutral-500 text-sm py-4">
                                    No data available.
                                </div>
                            </div>
                        </TabPanel>


                        <TabPanel>
                            <ul class="overflow-y-auto max-h-40 space-y-3">
                                <div v-if="announcementsToday.length" class="space-y-3">
                                    <li v-for="(announcement, index) in announcementsToday" :key="index" class="font-normal text-neutral-700 text-sm flex items-start py-3.5">
                                        <div
                                            class="text-white w-9 h-9 shrink-0 flex justify-center items-center bg-[#62c593] rounded-full mr-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24">
                                                <g fill="none" fill-rule="evenodd">
                                                    <path
                                                        d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                                    <path fill="currentColor"
                                                        d="M19 4.741V8a3 3 0 1 1 0 6v3c0 1.648-1.881 2.589-3.2 1.6l-2.06-1.546A8.66 8.66 0 0 0 10 15.446v2.844a2.71 2.71 0 0 1-5.316.744l-1.57-5.496a4.7 4.7 0 0 1 3.326-7.73l3.018-.168a9.34 9.34 0 0 0 4.19-1.259l2.344-1.368C17.326 2.236 19 3.197 19 4.741M5.634 15.078l.973 3.407A.71.71 0 0 0 8 18.29v-3.01l-1.56-.087a5 5 0 0 1-.806-.115M17 4.741L14.655 6.11A11.3 11.3 0 0 1 10 7.604v5.819c1.787.246 3.488.943 4.94 2.031L17 17zM8 7.724l-1.45.08a2.7 2.7 0 0 0-.17 5.377l.17.015l1.45.08zM19 10v2a1 1 0 0 0 .117-1.993z" />
                                                </g>
                                            </svg>
                                        </div>
                                        {{ announcement.content }}
                                    </li>
                                </div>
                                <div v-else class="text-center text-neutral-500 text-sm py-4">
                                    No data available.
                                </div>



                            </ul>
                        </TabPanel>


                    </TabPanels>
                </div>
            </TabGroup>
        </div>
    </div>
</template>

<script>
import { useDateStore } from '../stores/useDateStore';
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue';
import { BASE_URL, BASE_URL_POP } from "../config";
import axios from "axios";
import { createLocal } from 'the-storages';
const mirror = createLocal();
const storage = mirror._prx;
import dayjs from 'dayjs'
export default {
    name: 'RightSideBar',
    components: {
        TabGroup,
        TabList,
        Tab,
        TabPanels,
        TabPanel
    },
    data() {
        return {
            baseUrl: BASE_URL_POP + 'media/employeeProfile/',
            storage: storage,
            EventCategories: [
                {
                    id: 1,
                    name: 'Birthday',
                    data: [

                    ]
                },
                {
                    id: 1,
                    name: 'Work Anniversary',
                    data: [

                    ]
                },
                {
                    id: 1,
                    name: "Today's Announcement",
                    data: [

                    ]
                },
            ],
            orgSettingPercentage: '',
            // attendance_Setting_percentage:'',
            leave_Setting_percentage: '',
            // addemp_Setting_percentage:'',
            rosterdetails: '',
            newjoineeList: [],
            holidayList: [],
            anniversaries: [],
            birthdays: [],
            announcementsToday: [],
            date: new Date(), // Default to current date
        }
    },
    created() {
        this.fetchPercentageData();
        // this.fetchRosterDetails();
        // this.sendDataToParent();
        this.newjoineeDetails();
        this.fetchBirthdayList();
        this.dateStore = useDateStore();
        // ✅ Add this watch for dateStore.selectedDate
            this.$watch(
                () => this.dateStore.selectedDate,
                (newDate) => {
                    this.onDateChange(newDate);
                },
            );
    },

    computed: {

        upcomingBirthdays() {
            // Get the current date at midnight
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            // Get the date one week from now
            const oneWeekFromNow = new Date();
            oneWeekFromNow.setDate(currentDate.getDate() + 7);

            // Filter employees whose birthdays fall within the next month
            const upcomingBirthdays = this.newjoineeList.filter((employee) => {
                const employeeBirthday = new Date(employee.dob);
                employeeBirthday.setFullYear(currentDate.getFullYear()); // Set the year to the current year

                return (
                    employeeBirthday >= currentDate && employeeBirthday <= oneWeekFromNow
                );
            });

            // Sort the upcoming birthdays by the actual birthday date
            upcomingBirthdays.sort((a, b) => {
                const dateA = new Date(a.dob);
                const dateB = new Date(b.dob);
                dateA.setFullYear(currentDate.getFullYear());
                dateB.setFullYear(currentDate.getFullYear());
                return dateA.getTime() - dateB.getTime();
            });

            return upcomingBirthdays;
        },

        upcomingAnniversary() {
            // Get the current date at midnight
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            // Get the date one week from now
            const oneWeekFromNow = new Date();
            oneWeekFromNow.setDate(currentDate.getDate() + 7);

            // Filter employees whose birthdays fall within the next month
            const upcomingAnniversary = this.newjoineeList.filter((employee) => {
                const employeeAnniversary = new Date(employee.doj);
                employeeAnniversary.setFullYear(currentDate.getFullYear()); // Set the year to the current year

                return (
                    employeeAnniversary >= currentDate && employeeAnniversary <= oneWeekFromNow
                );
            });

            // Sort the upcoming birthdays by the actual birthday date
            upcomingAnniversary.sort((a, b) => {
                const dateA = new Date(a.doj);
                const dateB = new Date(b.doj);
                dateA.setFullYear(currentDate.getFullYear());
                dateB.setFullYear(currentDate.getFullYear());
                return dateA.getTime() - dateB.getTime();
            });

            return upcomingAnniversary;
        },


    },
    methods: {
        // async fetchRosterDetails(){
        //     await axios.post(BASE_URL + '/fetchRosterInfo',{'id':this.storage.companyDetails.id})
        //     .then((response)=>{
        //         console.log("SET AS DEFAULT DETAILS:: ",response.data);
        //         this.rosterdetails = response.data.result;
        //     })
        // },
        onDateChange(newDate) {
            this.date = newDate;
            //console.log("Date changed111:", newDate);
            this.fetchBirthdayList(); // fetch fresh data whenever the date changes
            this.fetchTodayAnnouncements();
            this.newjoineeDetails();
        },
        formatDate(date) {
            const d = new Date(date);
            return d.toLocaleDateString("en-US", {
                day: "2-digit",
                month: "short",
                year: "numeric"
            });
        },

        async fetchTodayAnnouncements() {
            //const today = new Date().toISOString().split('T')[0]; // 'YYYY-MM-DD'
             const formatted = this.formatDatee(this.date); // format the se
            const companyId = localStorage.getItem('company_id'); // Replace with dynamic company ID if needed

            const res = await axios.get(`${BASE_URL}/announcements/filter`, {
                params: {
                    company_id: companyId,
                    date: formatted
                }
            });

            this.announcementsToday = res.data;
        },


        async upcomingHolidays() {
            // Get the current date at midnight
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            // Get the date one week from now
            const oneWeekFromNow = new Date();
            oneWeekFromNow.setDate(currentDate.getDate() + 7);

            await axios.post(BASE_URL + '/fetchHolidayList', { 'id': this.storage.companyDetails.id })
                .then((response) => {
                    //console.log("SET AS DEFAULT DETAILS:: ", response.data);
                    this.holidayList = response.data.list;
                })

            // Filter employees whose birthdays fall within the next month
            const upcomingAnniversary = this.newjoineeList.filter((employee) => {
                const employeeAnniversary = new Date(employee.doj);
                employeeAnniversary.setFullYear(currentDate.getFullYear()); // Set the year to the current year

                return (
                    employeeAnniversary >= currentDate && employeeAnniversary <= oneWeekFromNow
                );
            });

            // Sort the upcoming birthdays by the actual birthday date
            upcomingAnniversary.sort((a, b) => {
                const dateA = new Date(a.doj);
                const dateB = new Date(b.doj);
                dateA.setFullYear(currentDate.getFullYear());
                dateB.setFullYear(currentDate.getFullYear());
                return dateA.getTime() - dateB.getTime();
            });

            return upcomingAnniversary;
        },

        async newjoineeDetails() {
             const formatted = this.formatDatee(this.date); // format the se
            await axios.post(BASE_URL + '/newjoineeDetails', { 'id': this.storage.companyDetails.id, 'date': formatted }, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.storage.token}`, } })
                .then((response) => {
                    if (response.data.status != 200) {
                        window.location.href = "/login";
                        localStorage.clear();

                    } else {
                        //console.log("SET AS DEFAULT DETAILS:: ", response.data);
                        this.newjoineeList = response.data.newjoineeList;
                    }

                })
        },

        async fetchPercentageData() {
            await axios.post(BASE_URL + '/initialSettingsCompletionPercentage', { 'id': this.storage.companyDetails.id }, { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.storage.token}`, } })
                .then((response) => {
                    //console.log("SET AS DEFAULT DETAILS:: ", response.data);
                    this.orgSettingPercentage = response.data.orgSettingPercentage;
                    // this.attendance_Setting_percentage = response.data.attendance_Setting_percentage;
                    this.leave_Setting_percentage = response.data.leave_Setting_percentage;
                    // this.addemp_Setting_percentage = response.data.addemp_Setting_percentage;
                })

            this.sendDataToParent();
        },

        sendDataToParent() {
            this.$emit('data-to-parent', {
                orgSettingPercentage: this.orgSettingPercentage,
                // attendance_Setting_percentage: this.attendance_Setting_percentage,
                leave_Setting_percentage: this.leave_Setting_percentage,
                // addemp_Setting_percentage: this.addemp_Setting_percentage,
            });
        },



        daysLeft(birthday) {
            const today = new Date();
            const birthdayDate = new Date(birthday);
            birthdayDate.setFullYear(today.getFullYear()); // Set the year to the current year

            // Calculate the difference in milliseconds
            const difference = birthdayDate - today;
            //console.log('difference', difference);
            // Calculate the number of days left
            const daysLeft = Math.ceil(difference / (1000 * 60 * 60 * 24));
            //console.log('daysLeft', daysLeft);

            if (daysLeft === 0) {
                return 'Today';
            } else if (daysLeft === 1) {
                return 'Tomorrow';
            } else {
                return `In ${daysLeft} days`;
            }
        },

        daysLeftAnniversary(doj) {
            const today = new Date();
            const dojDate = new Date(doj);
            dojDate.setFullYear(today.getFullYear()); // Set the year to the current year

            // Calculate the difference in milliseconds
            const difference = dojDate - today;
            //console.log('difference', difference);
            // Calculate the number of days left
            const daysLeft = Math.ceil(difference / (1000 * 60 * 60 * 24));
            //console.log('daysLeft', daysLeft);

            if (daysLeft === 0) {
                return 'Today';
            } else if (daysLeft === 1) {
                return 'Tomorrow';
            } else {
                return `In ${daysLeft} days`;
            }
        },
        formatDatee(date) {
            //console.log("Selected date:", date);
            const d = new Date(date);
            const year = d.getFullYear();
            const month = ('0' + (d.getMonth() + 1)).slice(-2);
            const day = ('0' + d.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        },

        async fetchBirthdayList() {
            try {
                //const response = await axios.post(BASE_URL + '/get-emp-birthday');
                 const formatted = this.formatDatee(this.date); // format the se
                 const response = await axios.post(BASE_URL + '/get-emp-birthday', {
                        company_id: this.storage.companyDetails.id,
                        date: formatted
                    });
                this.BirthdayData = response.data;
                // Convert object values to arrays
                this.birthdays = Object.values(response.data.birthdays || {});
                this.anniversaries = Object.values(response.data.anniversaries || {});
               // console.log("Birthday Data:", response.data);
            } catch (error) {
                console.error("Error fetching leave list:", error);
                //this.tostMessage('danger', 'Failed to fetch leave list');
            }
        },

        getYears(doj) {
            return dayjs().diff(dayjs(doj), 'year')
        },
        getGenderPronoun(gender) {
            const g = gender?.toLowerCase()
            if (g === 'male') return 'him'
            if (g === 'female') return 'her'
            return 'them'
        }

    },
    mounted() {
        this.fetchTodayAnnouncements(); // 👈 fetch today's only
    }

}
</script>